export class BaseError {
    constructor (public message: string, public description?: string, public code?: string) {
        Error.apply(this, arguments);
    }
}

BaseError.prototype = new Error();
